import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';

import amazoooom from '../../assets/images/amazoooom.png';
//import bill from '../../assets/images/bill.png';
import britishenergy from '../../assets/images/british-energy-crop.png';
import delivereatzz from '../../assets/images/delivereatzz-crop.png';
import friendlybook from '../../assets/images/friendlybook.png';
import offer from '../../assets/images/offer.png';
import payfriendly from '../../assets/images/payfriendly.png';


function Module11() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

  const handleSuccess = () => {
    {/* setCanContinue(true); */}
    // Client request: Go to the next page immediately if answer is correct (2 of 4)
    setCanContinue(false);
  };
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);

      // Show/hide popup div content
    const [activeDiv, setactiveDiv] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0); // Used to force re-render
  
    const handleOpen = (divId) => {
      setactiveDiv(divId);
      if (divId =='4' ){ // auto start the countdown on Popup div 4
        startCountdown();
      }
    };

    const handleClose = () => {
      setactiveDiv(null);
    };


  // Set if an is email phishing
  const [isPhishing, setIsPhishing] = useState(true); // default true

  const handleClickPhishingFalse = () => {
    setIsPhishing(false);
  };


  // Video Player
  const videoRef = useRef(null);
  
  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play(); // Plays the video
    }
  };

  // Timer adjust
  const { timeRemaining, formatTime, addPenalty, isRunning } = useTimer();
    
  const handleDecrease = () => {
    addPenalty();  // defaults to 1 minute or addPenalty(2) for a 2-minute penalty
  };

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 

    
  // Go to next page
  const { goNext } = usePageControl();
    

  return (
    <div id="module-11" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-email" className="box-wrapper-email-phishing">

                    <div id="email-client">
                      <div id="email-client-header"><h1 id="email-client-header-title">Email</h1></div>
                      <div id="email-client-body">
                        <div id="email-client-sidebar"><h2 id="email-client-sidebar-title">Inbox</h2></div>
                        <div id="email-client-content" className="email-client-content-phishing">

    <table id="email-table" className="email-table-phishing">
      <thead>
        <tr>
          <th className="email-table-td-padding">From</th>
          <th className="email-table-td-padding">Subject</th>
          <th className="email-table-td-padding"></th>
        </tr>
      </thead>
      <tbody>
        
        <tr>
          <td className="email-table-td-padding"><img src={britishenergy} className="email-logo" alt="British Energy logo"/></td>
          <td className="email-table-td-padding">
            <h2 className="email-subject">Urgent Action Required!</h2>
          </td>
          <td className="email-table-td-padding"><button className="btn btn-email ml-0 scale-85pc popup-trigger" onClick={() => { handleDecrease(); } }>Select</button></td>
        </tr>

        <tr>
          <td className="email-table-td-padding">haiku2120akio9@gmail.com</td>
          <td className="email-table-td-padding">
            <h2 className="email-subject">HELP!</h2>
          </td>
          <td className="email-table-td-padding"><button className="btn btn-email ml-0 scale-85pc popup-trigger" onClick={() => { handleDecrease(); } }>Select</button></td>
        </tr>

                <tr>
          <td className="email-table-td-padding"><img src={payfriendly} className="email-logo" alt="PayFriendly logo"/></td>
          <td className="email-table-td-padding">
            <h2 className="email-subject">Your credit card details</h2>
          </td>
          <td className="email-table-td-padding"><button className="btn btn-email ml-0 scale-85pc popup-trigger" onClick={() => { handleDecrease(); } }>Select</button></td>
        </tr>

        <tr>
          <td className="email-table-td-padding"><img src={delivereatzz} className="email-logo" alt="DeliverEatzz logo"/></td>
          <td className="email-table-td-padding">
            <h2 className="email-subject">10% off voucher</h2>
          </td>
          <td className="email-table-td-padding"><button className="btn btn-email ml-0 scale-85pc popup-trigger" onClick={() => { handleDecrease(); } }>Select</button></td>
        </tr>

                <tr>
          <td className="email-table-td-padding"><img src={friendlybook} className="email-logo" alt="FriendlyBook logo"/></td>
          <td className="email-table-td-padding">
            <h2 className="email-subject">Password reset</h2>
          </td>
          <td className="email-table-td-padding"><button className="btn btn-email ml-0 scale-85pc popup-trigger" onClick={() => { goNext(); } }>Select</button></td>
        </tr>

        <tr>
          <td className="email-table-td-padding"><img src={amazoooom} className="email-logo" alt="Amazoooom logo"/></td>
          <td className="email-table-td-padding">
            <h2 className="email-subject">Your account</h2>
          </td>
          <td className="email-table-td-padding"><button className="btn btn-email ml-0 scale-85pc popup-trigger" onClick={() => { handleDecrease(); } }>Select</button></td>
        </tr>

      </tbody>
    </table>

                      </div>
                    </div>

                    </div>
                  </div>

                {isPhishing &&  (

      <Popup
        title="Phish Food"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          {/* <button onClick={() => setShowPopup(false)} className={"btn" + " " + "btn-close"}><span className="visually-hidden">Close</span></button> */}
          <button onClick={() => setShowPopup(false)} className="btn">Close</button>
        </>
        }
      >
        <p>Oh no you've been phished! Minus 1 minute!</p>
        <p>Try again to find the real email.</p>
      </Popup>

                )}

                {!isPhishing &&  (

      <Popup
        title="Phish Free"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          {/* Client request: Go to the next page immediately if answer is correct (4 of 4) */}
          {/* <button className={"btn" + " " + "btn-close"} onClick={() => { handleClose(); handleSuccess(); setShowPopup(false) }}><span className="visually-hidden">Close</span></button> */}
          <button className="btn" onClick={() => { handleContinue(); }}>Close</button>
        </>
        }
      >
        <p>Well done! You selected the correct email.</p>
        <p>You can now continue.</p>
      </Popup>

                )}

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module11;
